import { render, staticRenderFns } from "./TenantInformation.vue?vue&type=template&id=24c6ffb0&scoped=true"
import script from "./TenantInformation.vue?vue&type=script&lang=js"
export * from "./TenantInformation.vue?vue&type=script&lang=js"
import style0 from "./TenantInformation.vue?vue&type=style&index=0&id=24c6ffb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6ffb0",
  null
  
)

export default component.exports